<template>
    <div>
        <NuxtLink :to="url" external>
            <NuxtImg :src="img" :alt="imgAlt !== '' ? imgAlt : title" />

            <div class="py-3">
                {{ title }}
            </div>
        </NuxtLink>
    </div>
</template>

<script setup lang="ts">
import {NuxtImg, NuxtLink} from '#components'

export interface ArticleCardProps {
    title: string;
    url?: string;
    img: string;
    imgAlt?: string;
}

const {title, img, url, imgAlt=''} = defineProps<ArticleCardProps>();

</script>